import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, ChapterLabel } from "@/components/Reveal";
import { useLang } from "@/i18n";

const LAYOUT = [
  { cls: "md:col-span-7", aspect: "aspect-[4/3]" },
  { cls: "md:col-span-5 md:mt-32", aspect: "aspect-[3/4] md:aspect-[4/5]" },
  { cls: "md:col-span-5", aspect: "aspect-[3/4] md:aspect-[4/5]" },
  { cls: "md:col-span-7 md:-mt-32", aspect: "aspect-[4/3]" },
];

const Classes = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const d = t.homeClasses;

  return (
    <section id="classes" data-testid="classes-section" className="bg-sand px-6 md:px-12 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px]">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <ChapterLabel index={d.chapter} title={d.label} />
            <Reveal delay={0.1}>
              <h2 data-testid="classes-headline"
                className="mt-10 font-display text-charcoal text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
                {d.headingA} <span className="italic font-light">{d.headingB}</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="max-w-sm">
            <p className="text-base leading-relaxed text-charcoal/65">{d.sub}</p>
          </Reveal>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 gap-16 md:grid-cols-12 md:gap-10">
          {d.items.map((item, i) => (
            <div key={item.name} className={LAYOUT[i % LAYOUT.length].cls}>
              <Reveal delay={0.08 * i} y={40}>
                <a href="/classes" data-testid={`class-${item.name.toLowerCase().replace(/\s+/g, "-")}-card`}
                  onClick={(e) => { e.preventDefault(); navigate("/classes"); }}
                  className="group block">
                  <div className="border-t border-charcoal/15 pt-5">
                    <p className="label-caps text-gold">{`0${i + 1}`}</p>
                    <h3 className="mt-2 font-display text-3xl text-charcoal md:text-4xl">{item.name}</h3>
                    {item.text && <p className="mt-2 text-sm text-charcoal/60">{item.text}</p>}
                  </div>
                  <div className={`img-frame mt-6 ${LAYOUT[i % LAYOUT.length].aspect}`}>
                    <img src={item.img} alt={item.alt} loading="lazy" className="h-full w-full object-cover" />
                  </div>
                  <div className="mt-4 flex justify-end">
                    <span className="u-link label-caps shrink-0 text-charcoal/70 group-hover:text-charcoal">
                      {d.explore}
                      <ArrowRight size={14} strokeWidth={1.5} className="u-arrow" />
                    </span>
                  </div>
                </a>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Classes;
